var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrebuiltIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32.233,
    height: 32.233,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c0cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#734cfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f4318d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ec5623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    x1: 1,
    x2: 0,
    y1: 0.757,
    y2: 0.242
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.233,
    height: 32.233,
    fill: "url(#a)",
    rx: 16.117
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 9.332a8.155 8.155 0 0 1 7-8.066v4.778a3.493 3.493 0 1 0 4.454 4.456h4.778A8.158 8.158 0 0 1 0 9.332m17.5 0h-7A2.334 2.334 0 0 0 8.166 7V0A9.343 9.343 0 0 1 17.5 9.332m-8.165-3.3a3.54 3.54 0 0 1 2.133 2.133h4.783a8.185 8.185 0 0 0-6.919-6.916Z",
    "data-name": "Combined Shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Color/Primary",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.233,
    height: 32.233,
    fill: "url(#a)",
    "data-name": "Mask",
    rx: 16.117
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    "data-name": "Color/Primary"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M0 0h32.233v32.233H0z",
    "data-name": "Color/Primary"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M7.368 16.7a8.155 8.155 0 0 1 7-8.066v4.778a3.493 3.493 0 1 0 4.454 4.456H23.6A8.158 8.158 0 0 1 7.368 16.7m17.5 0h-7a2.334 2.334 0 0 0-2.334-2.332v-7a9.343 9.343 0 0 1 9.334 9.332m-8.165-3.3a3.54 3.54 0 0 1 2.133 2.133h4.783A8.185 8.185 0 0 0 16.7 8.617Z",
    "data-name": "Combined Shape"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    "data-name": "Mask Group 6",
    transform: "translate(7.368 7.368)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uD83C\\uDFA8 color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ec5623",
    d: "M0 0h17.498v17.498H0z",
    "data-name": "Rectangle"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrebuiltIco);
export default __webpack_public_path__ + "static/media/prebuiltIco.e7441cc5ece6cd1d3af069b156059245.svg";
export { ForwardRef as ReactComponent };